export const registerSteps = {
  Exam: 'Exam',
  InquiryIdentityStatus: 'InquiryIdentityStatus',
  BirthDate: 'BirthDate',
  MofidLogin: 'MofidLogin',
  RedirectToOldReg: 'RedirectToOldReg',
  MofidOtp: 'MofidOtp',
  SejamVerifyOtp: 'SejamVerifyOtp',
  Password: 'Password',
  MofidVerifyOtp: 'MofidVerifyOtp',
  TraceCodeVerifyOtp: 'TraceCodeVerifyOtp',
  GetTraceCode: 'GetTraceCode',
  Finish: 'Finish',
  Signature: 'Signature',
  Video: 'Video',
  TraceCode: 'TraceCode',
  WaitingEkyc: 'WaitingEkyc',
  NationalCardSerial: 'NationalCardSerial',
  VerifyTraceCodOtp: 'VerifyTraceCodOtp',
  None: 'None',
  // Edit Sejam flow steps
  EditSejamMobile: 'EditSejamMobile',
  EditSejamData: 'EditSejamData',
  // profiling flow steps
  ProfileOtp: 'ProfileOtp',
  VerifyProfileOtp: 'VerifyProfileOtp',
  // contract flow steps
  VerifyEContractOtp: 'VerifyEContractOtp',
  Contact: 'Contact',
  EContract: 'EContract',
  // address flow steps
  InquiryPostalCode: 'InquiryPostalCode',
  UpdateAddress: 'UpdateAddress',
  ContactInfo: 'ContactInfo',
  InquiryAccount: 'InquiryAccount',
  Account: 'Account',
  TradingKnowledgeLevel: 'TradingKnowledgeLevel',
  SendToSejam: 'SendToSejam',
  EntryNodeVerifyOtp: 'EntryNodeVerifyOtp',
  EntryNodeShowMessage: 'EntryNodeShowMessage',
};

export const contractSteps = [
  registerSteps?.Contact,
  registerSteps?.EContract,
  registerSteps?.VerifyEContractOtp,
];

export const addressSteps = [
  registerSteps?.InquiryPostalCode,
  registerSteps?.UpdateAddress,
  registerSteps?.ContactInfo,
  registerSteps?.InquiryAccount,
  registerSteps?.Account,
  registerSteps?.TradingKnowledgeLevel,
  registerSteps?.SendToSejam,
  registerSteps?.EntryNodeVerifyOtp,
  registerSteps?.EntryNodeShowMessage,
];

export const profilingSteps = [
  registerSteps?.ProfileOtp,
  registerSteps?.VerifyProfileOtp,
];

export const editSejamSteps = [
  registerSteps?.EditSejamMobile,
  registerSteps?.EditSejamMobile,
];

export const initialRegisterSteps = [registerSteps?.None, null];

export const registerRedirectSteps = [
  registerSteps?.BirthDate,
  registerSteps?.InquiryIdentityStatus,
  registerSteps?.Exam,
  registerSteps?.MofidLogin,
  registerSteps?.RedirectToOldReg,
  registerSteps?.Finish,
  registerSteps?.Signature,
  registerSteps?.Video,
  registerSteps?.TraceCode,
  registerSteps?.WaitingEkyc,
  registerSteps?.NationalCardSerial,
  ...contractSteps,
  ...addressSteps,
  ...profilingSteps,
  ...initialRegisterSteps,
];
